import React, { Component } from 'react';

let keyWasPressed = false;

class BuscarMovimientosInput extends Component {
    constructor(props) {
        super(props);

        this.state = {
            textBusqueda: '',
            movimientosFiltrados: true
        }

        this.limpiarFiltro = this.limpiarFiltro.bind(this);
    }

    limpiarFiltro() {
        this.setState({ textBusqueda: "" });
        this.props.filtrarMovimientosPorDescripcion(this.props.dataModalFiltrosCargoAjuste);
    }

    onPasteText(e) {
        e.preventDefault();
        e.nativeEvent.stopImmediatePropagation();
    }


    addUser = (event) => {
        const { dataModalFiltrosCargoAjuste } = this.props;

        let valor = event.target.value.toString().toLowerCase();
        let movimientosEncontrados = undefined;

        if (valor != "") {
            movimientosEncontrados = dataModalFiltrosCargoAjuste.filter(x => x.CodigoDescripcion.toUpperCase().includes(valor.toUpperCase()));
        }

        if (movimientosEncontrados && movimientosEncontrados.length > 0 && !keyWasPressed && valor != "") {
            this.props.filtrarMovimientosPorDescripcion(movimientosEncontrados);

            this.setState({ textBusqueda: valor });
        }
        else if(valor == "") {
            this.props.filtrarMovimientosPorDescripcion(dataModalFiltrosCargoAjuste);

            this.setState({ textBusqueda: valor }); 
        } else {
            this.props.filtrarMovimientosPorDescripcion([]);

            this.setState({ textBusqueda: valor }); 
        } 


        keyWasPressed = false;
    }

    keyDown = (event) => {
        //backspace = 8, tab = 9, enter = 13, ctrol = 17, shift = 16, alt = 18, [left = 37, up = 38, rigth = 39, down = 40] (flechas)
        //=> no se deben considerar como tecla presionada

        let keyNotAllowed = [8, 9, 13, 16, 17, 18, 37, 38, 39, 40];

        if (keyNotAllowed.indexOf(event.keyCode) < 0) {
            keyWasPressed = false;
        }
    }

    onFocus = (event) => {
        keyWasPressed = false;
    }

    onKeyPress = (event) => {
        let regExp = /[a-z0-9 ]/ig;

        if (!regExp.test(event.key)) {
            event.preventDefault();
        }
    }

    render() {
        const { dataModalFiltrosCargoAjuste } = this.props;

        return (
            <div>
                <input 
                    type="text"
                    id="txtBusquedaMov"
                    className="form-control default-input ConfirmadorAjusteCargo-searchMotivoCargo"
                    value={this.state.textBusqueda}
                    maxLength="40"
                    onChange={this.addUser}
                    onKeyDown={this.keyDown}
                    onFocus={this.onFocus}
                    onKeyPress={(e) => this.onKeyPress(e)}
                    onPaste={this.onPasteText}
                    placeholder="Ingrese nombre"></input>

                {this.state.textBusqueda.length > 0 ?
                <div className="ConfirmadorAjusteCargo-btn-group-Borrar-Filtro">
                    <button id={"botonBorrarFiltroBuscarEntidad"} type="button" className="btn-tag ConfirmadorAjusteCargo-Filtros-Limpiar-Filtro"
                        onClick={this.limpiarFiltro}>
                        <span id={"botonBorrarXFiltroBuscarEntidad"} className="ti-close span-closable" />
                    </button>
                </div>
                :
                null}
            </div>
        );
    }
}

export default BuscarMovimientosInput;